export const CORRECT_CODE = "0x0000";
export const UNKNOWN_CODE = "Unknown";
export const REQUEST = "request";
export const RESPONSE = "response";
export const MESSAGE = "message";
export const CALLBACK = "Callback";
